import { apiService } from './apiService';

export const warehouseService = {
  // Get all warehouses
  async getWarehouses() {
    return await apiService.get('/warehouses');
  },

  async previewTransferFromStokbar() {
    return await apiService.post('/warehouses/preview-transfer-stokbar', {});
  },

  async transferFromStokbar(rows: any[]) {
    return await apiService.post('/warehouses/transfer-stokbar', { rows });
  },

  // Get warehouse by ID
  async getWarehouse(id: string | number) {
    return await apiService.get(`/warehouses/${id}`);
  },

  // Create warehouse
  async createWarehouse(data: any) {
    return await apiService.post('/warehouses', data);
  },

  // Update warehouse
  async updateWarehouse(id: string | number, data: any) {
    return await apiService.put(`/warehouses/${id}`, data);
  },

  // Delete warehouse
  async deleteWarehouse(id: string | number) {
    return await apiService.delete(`/warehouses/${id}`);
  },

  // Get ramps
  async getRamps(warehouseId?: string | number) {
    const query = warehouseId ? `?warehouseId=${warehouseId}` : '';
    return await apiService.get(`/warehouse-ramps${query}`);
  },

  async getRampPlanning(params: { warehouseId: string | number; shiftId: string | number }) {
    const query = new URLSearchParams({ warehouseId: String(params.warehouseId), shiftId: String(params.shiftId) }).toString();
    return await apiService.get(`/warehouse-ramps/planning?${query}`);
  },

  async saveRampPlanning(data: { warehouseId: string | number; shiftId: string | number; ramps: any[] }) {
    return await apiService.post('/warehouse-ramps/planning/save', data);
  },

  // Create ramp
  async createRamp(data: any) {
    return await apiService.post('/warehouse-ramps', data);
  },

  // Update ramp
  async updateRamp(id: string | number, data: any) {
    return await apiService.put(`/warehouse-ramps/${id}`, data);
  },

  // Delete ramp
  async deleteRamp(id: string | number) {
    return await apiService.delete(`/warehouse-ramps/${id}`);
  },

  // Get warehouse transfers
  async getTransfers(params?: { warehouseId?: string; status?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.warehouseId) {
      queryParams.append('fromWarehouse', params.warehouseId);
      queryParams.append('toWarehouse', params.warehouseId);
    }
    if (params?.status) queryParams.append('status', params.status);
    
    const query = queryParams.toString();
    return await apiService.get(`/warehouse-transfers${query ? `?${query}` : ''}`);
  },

  // Create transfer
  async createTransfer(data: any) {
    return await apiService.post('/warehouse-transfers', data);
  },

  // Update transfer
  async updateTransfer(id: string | number, data: any) {
    return await apiService.put(`/warehouse-transfers/${id}`, data);
  },

  // Delete transfer
  async deleteTransfer(id: string | number) {
    return await apiService.delete(`/warehouse-transfers/${id}`);
  },

  // Get waiting records
  async getWaitingRecords(params?: { shipmentId?: string; startDate?: string; endDate?: string; shipmentNo?: string; vehiclePlate?: string; driverName?: string; status?: string; source?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.shipmentId) queryParams.append('shipmentId', params.shipmentId);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    if (params?.shipmentNo) queryParams.append('shipmentNo', params.shipmentNo);
    if (params?.vehiclePlate) queryParams.append('vehiclePlate', params.vehiclePlate);
    if (params?.driverName) queryParams.append('driverName', params.driverName);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.source) queryParams.append('source', params.source);
    
    const query = queryParams.toString();
    return await apiService.get(`/waiting-records${query ? `?${query}` : ''}`);
  },

  // Create waiting record
  async createWaitingRecord(data: any) {
    return await apiService.post('/waiting-records', data);
  },

  async getMyActiveWaitingRecord() {
    return await apiService.get('/waiting-records/my-active');
  },

  async startMobileWaiting(data: { shipmentId?: number | string; latitude?: number; longitude?: number; recordedAt?: string; localRecordedAt?: string; locationSource?: string; locationDescription?: string }) {
    return await apiService.post('/waiting-records/start', data);
  },

  async stopMobileWaiting(id: string | number, data: { latitude?: number; longitude?: number; recordedAt?: string; localRecordedAt?: string; locationSource?: string; locationDescription?: string }) {
    return await apiService.post(`/waiting-records/${id}/stop`, data);
  },

  async getWaitingQueue(params?: { team?: 'operation' | 'customer-service'; ticketStatus?: 'open' | 'in-progress' | 'resolved' }) {
    const queryParams = new URLSearchParams();
    if (params?.team) queryParams.append('team', params.team);
    if (params?.ticketStatus) queryParams.append('ticketStatus', params.ticketStatus);
    const query = queryParams.toString();
    return await apiService.get(`/waiting-records/queue${query ? `?${query}` : ''}`);
  },

  async updateWaitingTicketStatus(id: string | number, data: { ticketStatus: 'open' | 'in-progress' | 'resolved'; queueTeam?: 'operation' | 'customer-service' }) {
    return await apiService.put(`/waiting-records/${id}/ticket-status`, data);
  },

  async replyWaitingRecord(id: string | number, data: { message: string; ticketStatus: 'in-progress' | 'resolved' }) {
    return await apiService.post(`/waiting-records/${id}/reply`, data);
  },

  async getWaitingSlaSummary(params?: { startDate?: string; endDate?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    const query = queryParams.toString();
    return await apiService.get(`/waiting-records/sla/summary${query ? `?${query}` : ''}`);
  },

  // Update waiting record
  async updateWaitingRecord(id: string | number, data: any) {
    return await apiService.put(`/waiting-records/${id}`, data);
  },

  // Delete waiting record
  async deleteWaitingRecord(id: string | number) {
    return await apiService.delete(`/waiting-records/${id}`);
  },
};
